import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43dcffb8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "crypto-choice-card"
};
const _hoisted_2 = { class: "container container-header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "grid-cell-5" }, null, -1));
const _hoisted_4 = { class: "grid-cell-1" };
const _hoisted_5 = { class: "grid-cell-2" };
const _hoisted_6 = { class: "grid-cell-3" };
const _hoisted_7 = { class: "grid-cell-4" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "grid-cell-5" };
const _hoisted_10 = { class: "grid-cell-1" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "grid-cell-2"
};
const _hoisted_13 = { class: "grid-cell-3" };
const _hoisted_14 = {
    key: 2,
    class: "grid-cell-4"
};
const _hoisted_15 = {
    key: 1,
    class: "crypto-choice-card"
};
const _hoisted_16 = { class: "loader" };
import { ref } from 'vue';
import { useStakingList } from '@/logics/stakinglist';
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null,
        isAuth: { type: Boolean }
    },
    emits: ["isList"],
    setup(__props, { emit }) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const FREE_PLAN = 1;
            const store = useStore();
            const { format, STAKING_LIST_HEADER, STAKING_LIST_CONTENT, DASHBOARD_PAGE } = useMessage();
            const { getStakingList } = useStakingList();
            const funds = ref([]);
            if (props.isAuth) {
                funds.value = (([__temp, __restore] = _withAsyncContext(() => getStakingList(props.userInfo.id).catch((err) => {
                    console.error(err);
                    return [];
                }))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            const fundDetails = (fund) => {
                emit('isList', false, fund);
            };
            return (_ctx, _cache) => {
                return (funds.value.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(_unref(STAKING_LIST_HEADER).QUANTITY)), 1),
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(STAKING_LIST_HEADER).PLAN)), 1),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(STAKING_LIST_HEADER).PLAN_INTEREST)), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(format)(_unref(STAKING_LIST_HEADER).REMAINING_DAYS)), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(funds.value, (fund) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: fund.id
                            }, [
                                _createElementVNode("div", {
                                    class: "container",
                                    onClick: ($event) => (fundDetails(fund))
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(CryptoIcon, {
                                            class: "crypto_icon",
                                            base: fund.cryptoName,
                                            width: 50
                                        }, null, 8, ["base"])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(fund.amount + fund.cryptoName.toUpperCase()), 1),
                                    (fund.term == FREE_PLAN)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(_unref(store).state.isSmartPhone ? 'grid-cell-2 grid-free-plan' : 'grid-cell-2')
                                        }, [
                                            _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_LIST_CONTENT).FREE)) + " ", 1),
                                            (_unref(store).state.isSmartPhone)
                                                ? (_openBlock(), _createElementBlock("br", _hoisted_11))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_LIST_CONTENT).PLAN)), 1)
                                        ], 2))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(fund.term + _unref(format)(_unref(STAKING_LIST_CONTENT).TERM)), 1)),
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(fund.term === FREE_PLAN ? '--' : fund.scheduledInterest + fund.cryptoName.toUpperCase()), 1),
                                    (fund.term !== FREE_PLAN)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(fund.remainingDays !== 0 ? _unref(format)(_unref(STAKING_LIST_CONTENT).REMAINING_DAYS_1) + fund.remainingDays + _unref(format)(_unref(STAKING_LIST_CONTENT).REMAINING_DAYS_2) : '--'), 1))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_8)
                            ]));
                        }), 128))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(format)(_unref(DASHBOARD_PAGE).EMPTY)), 1)
                    ]));
            };
        });
    }
});
